import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { ButtonPrimary } from '../../components/formelements';
import { getSession, processNum, processStrWithSpace } from '../../global';
import { createTicketCXMP, cxmpLogin, getAssignBranchCXMP, getAssignZoneCXMP, getCXMPTicketDetailById, getCnDetails, getRequestNatureCXMP, getRequestTypeCXMP, getRequestTypesAndDetails, getTicketInfo, updateTicket } from '../../services/complaintservice';
import { setLoading } from '../../redux/appSlice';

const Complaint = (props) => {
    const dispatch = useDispatch();
    //const cninfo = props.location.state || {};
    const cninfo = JSON.parse(sessionStorage.getItem('complaintData') || '{}');

    const cn = cninfo.cn;
    const codAmount = cninfo.codAmount;
    const screen = cninfo.screen;

    const { userInfo, codAmountLimit } = useSelector(state => state.appData);
    const history = useHistory();
    const d = {
        ticketNo: '',
        cn: '',
        requestNature: '1',
        requestNatureValue: 'Trace',
        requestType: '',
        requestTypeValue: '',
        inquireType: '1',
        zoneType: '1',
        branchType: '',
        status: null,
        launchBy: '',
        launchDate: '',
        comments: '',
        codAmount: cninfo?.codAmount ? cninfo.codAmount : 0
    };

    const cxmpD = {
        inquireType: '',
        zoneType: '',
        branchType: ''
    };

    const [cxmpData, setCxmpData] = useState(cxmpD)
    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);
    const [requestNatures, setRequestNatures] = useState([]);
    const [requestTypes, setRequestTypes] = useState([]);

    const [requestNaturesCXMP, setRequestNaturesCXMP] = useState([]);
    const [requestTypesCXMP, setRequestTypesCXMP] = useState([]);

    // const [inquireTypesCXMP, setInquireTypesCXMP] = useState([]);
    const [zoneTypesCXMP, setZoneTypesCXMP] = useState([]);
    const [branchTypesCXMP, setBranchTypesCXMP] = useState([]);
    const [user, setUser] = useState({})
    const [ticketDetail, setTicketDetail] = useState({})

    useEffect(() => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const initData = async () => {

            dispatch(setLoading({ data: true }));
            if (!cninfo.cn) {
                history.push('/tracking');
            }

            const rs2 = await getTicketInfo(cninfo.cn, source);
            const rsRnRt = await getRequestTypesAndDetails(source);

            if (rsRnRt.ok) {
                setRequestNatures(rsRnRt.data.types);
                setRequestTypes(rsRnRt.data.details);
            }

            const rsOne = await getCnDetails(cninfo.cn, source)
            if (rsOne.sts === 0) {
                setTicketDetail(rsOne.data[0])
            }

            const login = {
                Email: "cod.it@mulphilog.com",
                Password: "IiePuky7Z1+APYpc9UlDLQ=="
            }

            try {
                const rs = await cxmpLogin(login, source);

                dispatch(setLoading({ data: false }));
    
                const isCreate = (rs2.data.status === null || rs2.data.status === 0);

                if (rs?.IsSuccess && isCreate) {
                    setUser(rs.Data);
                    const rn = await getRequestNatureCXMP(rs.Data.Token, source);
                    if (rn?.IsSuccess) {
                        setRequestNaturesCXMP(rn.Data);
                    }
    
                    const rt = await getRequestTypeCXMP(2, rs.Data.Token, source);
                    if (rt?.IsSuccess) {
                        setRequestTypesCXMP(rt.Data)
                    }
    
                    // const zt = await getAssignZoneCXMP(0, rs.Data.Token, source);
                    // if (rn?.IsSuccess) {
                    //     setZoneTypesCXMP(zt.Data);
                    // }
    
                    // const ab = await getAssignBranchCXMP(1, rs.Data.Token, source)
                    // if (ab?.IsSuccess) {
                    //     setBranchTypesCXMP(ab.Data);
                    // }

                } else {
                    if(isCreate) {
                        alert(rs.msg)
                    }
                }

                if (rs2.ok) {
                    if (rs2.data.ticketNo) {
                        dispatch(setLoading({ data: true }));
                        const rsGetDetailCXMP = await getCXMPTicketDetailById(cninfo.cn, rs.Data.Token);
                        setCxmpData({ inquireType: rsGetDetailCXMP.Data?.Inquire_Type, zoneType: rsGetDetailCXMP.Data?.AssignZoneName, branchType: rsGetDetailCXMP.Data?.AssignBranchName })
                        dispatch(setLoading({ data: false }));
                        const { details, ...rest } = rs2.data;
                        setData(rest);
                        setGrid(details || []);
                    }
                }

            } catch(e) {
                alert("Something went wrong. \n", e)
                dispatch(setLoading({ data: false }));
            }
        }
        initData();
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, []);

    const updateData = (key, val) => setData({ ...data, [key]: val });

    const onTicketUpdate = async () => {
        const isCreate = (data.status === null || data.status === 0);

        if (isCreate) {
            if (!data.requestNature) {
                alert("Select Nature")
            }

            // we will check/match old data to new that it is available in new data or not

            if (!requestNaturesCXMP.map(e => e.Text.toUpperCase()).includes(requestNatures.filter(e => e.value === Number(data.requestNature))[0].text.toUpperCase())) {
                alert("Only Trace or Complaints Request can be logged");
                return;
            }

            if (!data.requestType) {
                alert('Select Request Type');
                return;
            }


            if (data.requestNature == "1" && data.requestType == "70") {
                
                if (!data.codAmount || data.codAmount === 0) {
                    alert('COD Amount is required.');
                    return false;
                }

                if (!userInfo.isZeroCodAllowed) {
                    if (+data.codAmount <= 0) {
                        alert('Cod Amount must be greater than 0');
                        return false;
                    }
                }

                const amountLimitCheck = codAmountLimit?.length > 0 && codAmountLimit?.filter(i => i.accountNo.toUpperCase() == ticketDetail.Account_No.toUpperCase());
                let codAmountL = 99999;
                if(amountLimitCheck.length > 0) {
                    codAmountL = amountLimitCheck[0].amount;
                }

                if (+data.codAmount > codAmountL) {
                    alert(`Cod Amount must be less than ${codAmountL}`);
                    return false;
                }
            }

            // we will check/match old data to new that it is available in new data or not

            if (requestNaturesCXMP.filter(e => e.Text.toUpperCase() === data.requestNatureValue.toUpperCase())[0].Text.toUpperCase() === "TRACE" && !requestTypesCXMP.map(e => e.Text.toUpperCase()).includes(data.requestTypeValue.toUpperCase())) {
                //Trace Nature does not contain this type in CXMP database
                alert("Trace does not contain this type.");
                return;
            }

            // we will check/match old data to new that it is available in new data or not

            if (requestNaturesCXMP.filter(e => e.Text.toUpperCase() === data.requestNatureValue.toUpperCase())[0].Text.toUpperCase() === "COMPLAINT" && !requestTypesCXMP.map(e => e.Text.toUpperCase()).includes(data.requestTypeValue.toUpperCase())) {
                //Complaint Nature does not contain this type in CXMP database
                alert("Complaint does not contain this type.");
                return;
            }

            // getting CXMP request nature ID by name
            const requestNatureCXMPId = requestNaturesCXMP.filter(e => e.Text.toUpperCase() === data.requestNatureValue.toUpperCase())[0].Value;

            const requestTypeCXMPId = requestTypesCXMP.filter(e => e.Text.toUpperCase() === data.requestTypeValue.toUpperCase())[0].Value;


            if (!data.comments || data.comments.trim() === '') {
                alert('Enter Comments');
                return;
            }

            // Payload created for old
            const z = {
                ticketNo: Number(data.ticketNo),
                userId: userInfo.id,
                userName: userInfo.name,
                cn: cninfo.cn,
                requestNature: isNaN(data.requestNature) ? 0 : Number(data.requestNature),
                requestType: isNaN(data.requestType) ? 0 : Number(data.requestType),
                comments: data.comments,
                isCreate: isCreate,
                codAmount: String(data.codAmount)
            }

            dispatch(setLoading({ data: true }));
            const rs = await updateTicket(z);
            alert(rs.msg);
            if (rs.ok) {

                const z = {
                    "RequestNature_Id": Number(requestNatureCXMPId),
                    "RequestType_Id": Number(requestTypeCXMPId),
                    "CN": cninfo.cn,
                    "InquireType": Number(data.inquireType),
                    "InquireName": ticketDetail.inquireName,
                    "Email": ticketDetail.email,
                    "Phone": ticketDetail.phoneNo,
                    "Account_No": ticketDetail.Account_No,
                    "Weight": String(ticketDetail.weight),
                    "Pieces": String(ticketDetail.pieces),
                    "Product_Name": ticketDetail.product_name,
                    "ShipperName": ticketDetail.ShipperName,
                    "ShipperCell": ticketDetail.consignerPhoneNo,
                    "ShipperAddress": ticketDetail.shipperAddress,
                    "ConsigneeName": ticketDetail.ConsigneeName,
                    "ConsigneeCell": ticketDetail.ConsigneeCell,
                    "ConsigneeAddress": ticketDetail.ConsigneeAddress,
                    "AssignZone": Number(ticketDetail.zoneCode),
                    "AssignBranch": Number(ticketDetail.DestinationCode),
                    "Remarks": ticketDetail.remarks,
                    "Destination": Number(ticketDetail.DestinationCode),
                    "OriginLocation": Number(ticketDetail.OriginLocationCode),
                    "codAmount": String(data.codAmount)
                }

                const rsCXMP = await createTicketCXMP(z, user.Token);
                if (!rsCXMP.data && rsCXMP.Status_Code === 200) {
                    const rsGetDetailCXMP = await getCXMPTicketDetailById(cninfo.cn, user.Token);
                    setCxmpData({ inquireType: rsGetDetailCXMP.Data?.Inquire_Type, zoneType: rsGetDetailCXMP.Data?.AssignZoneName, branchType: rsGetDetailCXMP.Data?.AssignBranchName })
                }

                dispatch(setLoading({ data: false }));

                const { details, ...rest } = rs.data;
                setData({ ...rest, comments: '' });
                setGrid(details || []);
            } else {
                alert(rs.msg)
            }
        } else {
            if (isCreate && !data.requestType) {
                alert('Select Request Type');
                return;
            }

            if (!data.comments || data.comments.trim() === '') {
                alert('Enter Comments');
                return;
            }

            const z = {
                ticketNo: Number(data.ticketNo),
                userId: userInfo.id,
                userName: userInfo.name,
                cn: cninfo.cn,
                requestNature: isNaN(data.requestNature) ? 0 : Number(data.requestNature),
                requestType: isNaN(data.requestType) ? 0 : Number(data.requestType),
                comments: data.comments,
                isCreate: isCreate
            }

            dispatch(setLoading({ data: true }));
            const rs = await updateTicket(z);
            dispatch(setLoading({ data: false }));
            alert(rs.msg);
            if (rs.ok) {
                const { details, ...rest } = rs.data;
                setData({ ...rest, comments: '' });
                setGrid(details || []);
            }
        }
    }

    return getSession('userInfo') && <section className="section">
        <div className="section-header">
            <h1>Complaint</h1>
        </div>
        <div className="card" style={{
            padding: 10
        }}>
            <div className="row mt-2">
                <div className="col-12 text-center p-2">
                    <h2 style={{
                        fontSize: '20px',
                    }}>Ticket Info</h2>
                </div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top"><b>Consignment Number</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top">
                    <a style={{ cursor: 'pointer', color: '#e25a0c' }} onClick={e => {
                        e.preventDefault();
                        history.push({
                            pathname: cninfo.screen,
                            state: { cn: cninfo.cn }
                        });
                    }}><b>{cninfo.cn}</b>
                    </a></div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top border-left"><b>Launch By</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top">{ticketDetail?.inquireName}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top border-left"><b>Inquirer Email</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top">{ticketDetail.email}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom"><b>Inquirer Phone</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.phoneNo}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Account No</b></div>
                <div className="col-md-2 col-sm-12 pb-2  border-bottom">{ticketDetail.Account_No}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Product Name</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.product_name}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom"><b>Pieces</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.pieces}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Weight</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.weight}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Origin Location</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.OriginLocation}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom"><b>Destination</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.Destination}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>ShipperName</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.ShipperName}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Shipper Address</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.shipperAddress}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom"><b>Shipper Phone No</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.consignerPhoneNo}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Consignee Name</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.ConsigneeName}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Consignee Cell</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.ConsigneeCell}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom"><b>Consignee Address</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.ConsigneeAddress}</div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Remarks</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{ticketDetail.remarks}</div>

                {/* <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Inquire Type</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">{(data.status === null || data.status === 0) ?
                    <select className="form-select" value={data.inquireType} onChange={e => updateData('inquireType', e.target.value)}>
                        <option value="">Select Type</option>
                        {
                            inquireTypesCXMP.map((x, index) => <option key={index} value={x.Value}>{x.Text}</option>)
                        }
                    </select> : cxmpData.inquireType}
                </div> */}

                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Inquire Type</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">Consignee</div>

                {/* <div className="col-md-2 col-sm-12 pb-2 border-bottom"><b>Request Nature</b></div> */}
                {/* <div className="col-md-2 col-sm-12 pb-2 border-bottom">{
                    (data.status === null || data.status === 0) ?
                        <select className="form-select" value={data.requestNature} onChange={async e => {
                            const text = e.target[e.target.selectedIndex].getAttribute('data-text');
                            setData({ ...data, requestNature: e.target.value, requestNatureValue: text, requestType: '' });
                            const cxmpId = requestNaturesCXMP.filter(e => e.Text === text)[0].Value;
                            if (e.target.value) {
                                const rt = await getRequestTypeCXMP(cxmpId, user.Token)
                                if (rt.IsSuccess)
                                    setRequestTypesCXMP(rt.Data)
                            } else {
                                setRequestTypesCXMP([])
                            }
                        }}>
                            {
                                requestNatures.map((x, index) => <option key={index} data-text={x.text} value={x.value}>{x.text}</option>)
                            }
                        </select> : data.requestNature}
                </div> */}

                <div className="col-md-2 col-sm-12 pb-2 border-bottom"><b>Request Type</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-right">{
                    (data.status === null || data.status === 0) ?
                        <select className="form-select" value={data.requestType} onChange={async e => {
                            if (e.target.value) {
                                const text = e.target[e.target.selectedIndex].getAttribute('data-text');
                                const requestType = e.target[e.target.selectedIndex].getAttribute('data-requesttype');
                                const reqnature = requestNatures.filter(e => Number(e.value) == Number(requestType))[0];

                                setData({ ...data, requestNature: reqnature.value, requestNatureValue: reqnature.text, requestType: e.target.value, requestTypeValue: text })
                                const cxmpId = requestNaturesCXMP.filter(e => e.Text ===  reqnature.text)[0].Value;
                                const rt = await getRequestTypeCXMP(cxmpId, user.Token)

                                if (rt.IsSuccess) {
                                    setRequestTypesCXMP(rt.Data)
                                } else {
                                    setRequestTypesCXMP([])
                                }
                            } 
                        }
                        }>
                            <option value="">Select Type</option>
                            {
                                requestTypes.map((x, index) => <option key={index} data-requesttype={x.requestType} data-text={x.text} value={x.value}>{x.text}</option>)
                            }
                        </select> : data.requestType}
                </div>
                {
                   (Number(data.requestType) === 70 || data.requestType === 'COD Amount Change') ? <>
                        <div className="col-md-2 col-sm-12 pb-2 border-bottom "><b>COD Amount</b></div>
                        <div className="col-md-2 col-sm-12 pb-2 border-bottom border-right">{
                            (data.status === null || data.status === 0) ?
                                <>
                                    <input type="number" className="form-control" maxLength={7} value={data.codAmount} onInput={processNum} onChange={(e) => updateData('codAmount', Math.round(e.target.value))} />
                                </> : data.codAmount
                        }</div>
                    </> : <></>
                }

                {/* <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left"><b>Assign Zone</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom">
                    {
                        ticketDetail.zoneName
                    }
                </div>

                <div className="col-md-2 col-sm-12 pb-2 border-bottom  border-left"><b>Assign Branch</b></div>
                <div className="col-md-2 col-sm-12 pb-2 border-bottom border-right">{ticketDetail.Destination}</div> */}
            </div>
            <div className="row mt-2">
                <div className="col-12" style={{ textAlign: 'right' }}>
                    <ButtonPrimary text={(data.status === null || data.status === 0) ? 'Create' : 'Update'} onClick={onTicketUpdate} />
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-12 text-center p-2">
                    <h3 style={{ fontSize: 20 }}>Ticket Details</h3>
                </div>
                <div className="col-12">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Launch By</th>
                                <th>Date Time</th>
                                <th>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Customer</td>
                                <td></td>
                                <td className="p-2">
                                    <textarea className="form-control" value={data.comments} onInput={processStrWithSpace} onChange={e => updateData('comments', e.target.value)}></textarea>
                                </td>
                            </tr>
                            {
                                grid.length > 0 && grid.map((x, index) =>
                                    <tr key={index}>
                                        <td>{index + 2}</td>
                                        <td>{x.launchBy}</td>
                                        <td>{x.launchDate}</td>
                                        <td>{x.comments}</td>
                                    </tr>)
                            }
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </section>
}

export default Complaint
